// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"f213fd70","667":"482a7c57"}[chunkId] + ".chunk.css";
};